import { __read } from "tslib";
import React, { useEffect, useState } from 'react';
import { LayoutContext } from './hooks/useLayoutContext';
export var LayoutSwitchControl = function (_a) {
    var children = _a.children, defaultLayout = _a.defaultLayout;
    var _b = __read(useState(defaultLayout), 2), currentLayout = _b[0], setCurrentLayout = _b[1];
    var value = {
        currentLayout: currentLayout,
        setCurrentLayout: setCurrentLayout,
    };
    // The useEffect block below makes defaultLayout an overriding prop. This is needed because
    // getting the correct defaultLayout can take time, so data might be ready only after control
    // has already rendered with the default option.
    useEffect(function () {
        if (defaultLayout) {
            setCurrentLayout(function (layout) {
                return layout === defaultLayout ? layout : defaultLayout;
            });
        }
    }, [defaultLayout]);
    return (React.createElement(LayoutContext.Provider, { value: value }, children));
};
//# sourceMappingURL=LayoutSwitchControl.js.map